import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false, 
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const blogsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.BLOG_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case actions.BLOG_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case actions.BLOG_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.BLOGS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.BLOGS_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.BLOGS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.BLOG_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.BLOG_UPDATE_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.BLOG_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const blogReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.BLOG_READ_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case actions.BLOG_READ_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case actions.BLOG_READ_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { blogsReducer, blogReducer };
